var disableSubmitBtn = require('./_submitBtnDisable');

module.exports = function formSubmitDisable(form, e, btn) {
	if ( form.checkValidity && !form.checkValidity() ) {
    } else {
    	disableSubmitBtn(btn);
    }
};